import { render } from "./adult.view.vue?vue&type=template&id=510e2728&scoped=true&ts=true"
import script from "./adult.view.vue?vue&type=script&lang=ts"
export * from "./adult.view.vue?vue&type=script&lang=ts"

import "./adult.view.vue?vue&type=style&index=0&id=510e2728&scoped=true&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510e2728"]])

export default __exports__